module.exports = "/static/assets/13f7d9eda10cb6bb16b313ec8d90b3a8.png";